import styled from 'styled-components';
import { mediaQueries, MOBILE_MENU_BREAKPOINT } from 'developer-docs-shared-components/utils/mediaQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const Div = styled.div.withConfig({
  displayName: "DndSection__Div",
  componentId: "sc-1ygvobu-0"
})(["", "{display:flex;justify-content:space-between;gap:2.564102564%;}"], mediaQueries.aboveWidth(MOBILE_MENU_BREAKPOINT));

/**
 * @deprecated
 * A  drag and drop (Dnd) section extracted from the CMS. Contains children that
 * have set widths according to a 12-column grid.
 */
const DndSection = props => /*#__PURE__*/_jsx(Div, Object.assign({
  "data-type": "dnd-section"
}, props));
export default DndSection;